module.exports = __webpack_public_path__ + "img/share-btn-left.e77c9dc7.png";